require('./page-context.scss');

const PageContextComponent = {
    selector: 'sbPageContext',
    template: require('./page-context.html'),
    transclude: true,
};

export default PageContextComponent;



// WEBPACK FOOTER //
// ./src/app/components/page-context/index.js